import React from "react";

const ExpiredPopup = ({ isOpen, onClose, title = "Product is past it's best use date", message }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 pt-5 pb-5 shadow-lg rounded-lg z-50 w-80">
            <button
                className="absolute top-2 right-2 bg-black text-white rounded-full w-8 h-8 flex items-center justify-center font-bold"
                onClick={onClose}
            >
                &times;
            </button>
            <div className="text-center d-flex align-items-center">
                <img src="img/expired.png" alt="error" className="w-24 h-24 mx-auto mb-2" />
                <div>
                    <h3 className="text-base font-semibold">{title}</h3>
                    <p className="text-sm text-gray-600 mt-1">{message}</p>
                </div>

                {/* <img src="img/error.png" alt="error" className="" /> */}
                
            </div>
        </div>
    );
};

export default ExpiredPopup;


